// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"846":"4c4043f8","913":"f6982e1a","995":"8f094a37"}[chunkId] + ".css";
};